export default {
  bf_headers: function(api_token) {
    return { headers: { "Authorization": api_token } }
  },
}
